import React, {Component} from 'react'
import update from 'immutability-helper'
import GoodBeat from '../GoodBeat/GoodBeat'
import GoodBeatSlider from './GoodBeatSlider/GoodBeatSlider'
import goodBeatData from './goodBeatData'
import './GoodBeat.css'

class GoodBeatContainer extends Component {
  constructor() {
    super()
    this.state = {
      goodBeats: goodBeatData,
      visible: false
    }
  }

  componentDidUpdate() {
    if (this.props.goodBeatShouldStop) {
      this.props.handleGoodBeatStop()
      const currentBeat = this.state.goodBeats.find(b => b.playing)
      const currentNum = this.state.goodBeats.indexOf(currentBeat)
      currentBeat.track.stop()
      const newData = update(this.state.goodBeats, {
        [currentNum]: {
          playing: {$set: false}
        }
      })
      this.setState({
        goodBeats: newData,
        visible: false
      })
    }
  }

  handleGoodBeat(name) {
    const beat = this.state.goodBeats.find(b => b.name === name)
    const beatNum = this.state.goodBeats.indexOf(beat)
    const currentBeat = this.state.goodBeats.find(b => b.playing)
    const currentNum = this.state.goodBeats.indexOf(currentBeat)
    if (beat.track.loaded) {
      this.props.handlePlayerStop()
      let newData = {}
      if (currentBeat && currentBeat !== beat) {
        currentBeat.track.stop()
        beat.track.start()
        newData = update(this.state.goodBeats, {
          [currentNum]: {
            playing: {$set: false}
          }, [beatNum]: {
            playing: {$set: true}
          }
        })
      } else {
        beat.track.start()
        newData = update(this.state.goodBeats, {
          [beatNum]: {
            playing: {$set: true}
          }
        })
      }
      this.setState({
        goodBeats: newData
      })
    }
  }

  handleVisibility() {
    const update = this.state.visible ? false : true
    this.setState({
      visible: update
    })
  }

  handleVolume(e) {
    const newVol = Math.round((Math.pow(6.3 * e.target.value, 0.6) - 48))
    this.state.goodBeats.forEach((track, index) => {
      const newData = update(this.state.goodBeats, {
        [index]: {
          track: {volume: {value: {$set: newVol}}}
        }
      })
      this.setState({
        goodBeats: newData
      })
    })
  }

  render() {
    const beatClass = this.state.visible ? '' : 'beatsHide'
    const goodBeats = this.state.goodBeats.map(beat => (
      <GoodBeat 
        key={beat.id}
        name={beat.name}
        handleGoodBeat={name => this.handleGoodBeat(name)}
      />
    ))
    return (
      <div className='goodBeatContainer'>
        <div className='goodBeatTitleContainer'>
          <h3 className='subtitle goodBeatTitle'
            onClick={() => this.handleVisibility()}
          >Classic Beats</h3>
        </div>
        <div className={'goodBeatControls ' + beatClass}>
          <div className='goodBeatBox'>
            {goodBeats}
          </div>
          <GoodBeatSlider handleVolume={e => this.handleVolume(e)}/>
        </div>
      </div>
    )
  }
}

export default GoodBeatContainer


// WEBPACK FOOTER //
// ./src/GoodBeat/GoodBeatContainer.js